module["exports"] = [
  "شيفروليه",
  "كاديلاك",
  "فورد",
  "كرايسلر",
  "دودج",
  "جيب",
  "تسلا",
  "تويوتا",
  "هوندا",
  "نيسان",
  "أودي",
  "مرسيدس بنز",
  "بي إم دبليو",
  "فولكس واجن",
  "بورش",
  "جاكوار",
  "استون مارتن",
  "لاند روفر",
  "بنتلي",
  "ميني",
  "رولزرويس",
  "فيات",
  "لامبورغيني",
  "مازيراتي",
  "فيراري",
  "بوجاتي",
  "كيا",
  "هيونداي"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ar/vehicle/manufacturer.js
// module id = 2403
// module chunks = 1610